<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div>
    <header class="bar bar-nav">
      <router-link :to="{name : 'orderContentConfirm'}" class="button button-link button-nav pull-left">
        <span class="icon icon-left" style="font-size: 18px">返回</span>
      </router-link>
      <h1 class="title">编辑收货地址</h1>
    </header>
    <div class="content">
      <div class="list-block">
        <ul>
          <!-- Text inputs -->
          <li>
            <div class="item-content">
              <!--<div class="item-media"><i class="icon icon-form-name"></i></div>-->
              <div class="item-inner">
                <div class="item-title label">收货人</div>
                <div class="item-input">
                  <input type="text" placeholder="Your name">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <!--<div class="item-media"><i class="icon icon-form-email"></i></div>-->
              <div class="item-inner">
                <div class="item-title label">手机号码</div>
                <div class="item-input">
                  <input type="phoneNumber" placeholder="Phone Number">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <!--<div class="item-media"><i class="icon icon-form-password"></i></div>-->
              <div class="item-inner">
                <div class="item-title label">所在地区</div>
                <div class="item-input">
                  <input type="password" placeholder="area" class="">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-gender"></i></div>
              <div class="item-inner">
                <div class="item-title label">Gender</div>
                <div class="item-input">
                  <select>
                    <option>Male</option>
                    <option>Female</option>
                  </select>
                </div>
              </div>
            </div>
          </li>
          <!-- Date -->
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-calendar"></i></div>
              <div class="item-inner">
                <div class="item-title label">Birthday</div>
                <div class="item-input">
                  <input type="date" placeholder="Birth day" value="2014-04-30">
                </div>
              </div>
            </div>
          </li>
          <!-- Switch (Checkbox) -->
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-toggle"></i></div>
              <div class="item-inner">
                <div class="item-title label">Switch</div>
                <div class="item-input">
                  <label class="label-switch">
                    <input type="checkbox">
                    <div class="checkbox"></div>
                  </label>
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-comment"></i></div>
              <div class="item-inner">
                <div class="item-title label">Textarea</div>
                <div class="item-input">
                  <textarea></textarea>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-50"><a href="#" class="button button-big button-fill button-danger">Cancel</a></div>
          <div class="col-50"><a href="#" class="button button-big button-fill button-success">Submit</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// AddressDetail.vue?5d7aa04b